import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export enum CARD_SELECTION_SCREEN {
  LOADING = 'LOADING',
  CARD_SELECTION = 'CARD_SELECTION',
  CONFIRM_ADDRESS = 'CONFIRM_ADDRESS',
  CONFIRM_ADDRESS_LATER = 'CONFIRM_ADDRESS_LATER',
}

export interface CardSelectionState {
  screen: CARD_SELECTION_SCREEN;
  selectedCardDesignID: string;
}

const initialState: CardSelectionState = {
  screen: CARD_SELECTION_SCREEN.LOADING,
  selectedCardDesignID: '',
};

const cardDesignSlice = createSlice({
  name: 'cardDesign',
  initialState,
  reducers: {
    setCardDesignSelectionScreen: (
      state,
      action: PayloadAction<CARD_SELECTION_SCREEN>
    ) => {
      state.screen = action.payload;
    },
    setSelectedCardDesignID: (state, action: PayloadAction<string>) => {
      state.selectedCardDesignID = action.payload;
    },
  },
});

export const { setCardDesignSelectionScreen, setSelectedCardDesignID } =
  cardDesignSlice.actions;
export default cardDesignSlice.reducer;
